import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';
import { formatPdpCarat } from '@/features/pdp/utils/formatPdpCarat';
import type { ProductStoneDetailsInput } from '@/features/pdp/utils/productDetailStones';
import { hasSolitaireDetails } from '@/features/pdp/utils/productDetailStones';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

interface PdpDesktopSolitaireDetailsProps {
  onInfoIconClick?: (label: string) => void;
}

export function PdpDesktopSolitaireDetailsSummary({
  onInfoIconClick,
  ...input
}: ProductStoneDetailsInput & PdpDesktopSolitaireDetailsProps) {
  if (!hasSolitaireDetails(input)) {
    return null;
  }

  return (
    <>
      {input.solitaireCarat ? (
        <PdpDesktopDetailRow
          label="Total Weight"
          value={`${formatPdpCarat(input.solitaireCarat)} Ct`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
      {input.solitaireTotalNoOfStones ? (
        <PdpDesktopDetailRow
          label="Total No. of Solitaires"
          value={input.solitaireTotalNoOfStones}
        />
      ) : null}
    </>
  );
}

export function PdpDesktopSolitaireDetailsExpanded(input: ProductStoneDetailsInput) {
  if (!hasSolitaireDetails(input)) {
    return null;
  }

  return (
    <>
      {input.solitaireShape ? (
        <PdpDesktopDetailRow label="Shape" value={input.solitaireShape} />
      ) : null}
      {input.solitaireClarity ? (
        <PdpDesktopDetailRow label="Clarity" value={input.solitaireClarity} />
      ) : null}
      {input.solitaireColor ? (
        <PdpDesktopDetailRow label="Color" value={input.solitaireColor} />
      ) : null}
      {input.solitaireCutPolishSymmetry ? (
        <PdpDesktopDetailRow
          label="Cut-Polish-Symmetry"
          value={input.solitaireCutPolishSymmetry}
        />
      ) : null}
      {input.solitaireFluorescence ? (
        <PdpDesktopDetailRow label="Fluorescence" value={input.solitaireFluorescence} />
      ) : null}
    </>
  );
}
